import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/auth/auth.guard';
import { AuthAfterGoogle } from './component/authaftergoogle/authaftergoogle.component';
import { DocViewerComponent } from './shared/doc-viewer/doc-viewer.component';
import { PdfViewerComponent } from './shared/pdf-viewer/pdf-viewer.component';
import { ExcelViewerComponent } from './shared/excel-viewer/excel-viewer.component';
import { NavigateDetailsComponent, NotFoundComponent } from '@shared/common';

export const routerOptions: ExtraOptions = {
	scrollPositionRestoration: 'enabled',
	anchorScrolling: 'enabled',
	scrollOffset: [0, 64],
};

export const routes = [
	{
		path: '',
		canActivateChild: [AuthGuard],
		loadChildren: () => import('./component/landing-page/landing.module').then(m => m.LandingPageModule),
	},
	{
		path: 'signin',
		loadChildren: () => import('./component/sign-in/sign-in.module').then(m => m.SignInModule),
	},
	{
		path: 'forgot',
		loadChildren: () => import('./component/forgot-pass/forgot-pass.module').then(m => m.ForgotPassModule),
	},
	{
		path: 'resetpassword',
		loadChildren: () => import('@shared/common').then(m => m.resetPasswordRoutes),
	},
	{
		path: 'linksend',
		loadChildren: () => import('./component/link-send/link-send.module').then(m => m.LinkSendModule),
	},
	{
		path: 'verify',
		loadChildren: () => import('./component/sign-in/sign-in.module').then(m => m.SignInModule),
	},
	{
		path: 'afterauthgoogle',
		component: AuthAfterGoogle,
	},
	{
		path: '404',
		component: NotFoundComponent,
	},
	{
		path: 'navigate-details/:controller/:action/:params',
		component: NavigateDetailsComponent,
	},
	{
		path: 'doc',
		component: DocViewerComponent,
	},
	{
		path: 'pdf',
		component: PdfViewerComponent,
	},
	{
		path: 'excel',
		component: ExcelViewerComponent,
	},
	{
		path: '**',
		redirectTo: '/404',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, routerOptions)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
